
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import rely from '@/nmb/oauth2/oauth2rely';
import axios from 'axios';
import config from '@/params/config';

@Component
export default class Attachment extends Vue {
  @Prop() attachmentData: any[];
  @Prop() isJira: boolean;
  previewVisible: boolean = false;
  previewFileUrl: string = '';
  selectedAttachment: any[] = [];
  tokens: any;

  created() {
    this.tokens = rely.getTokens();
  }

  // 选择需要下载的附件
  handleSelectionChange(val: any[]) {
    this.selectedAttachment = val;
  }

  previewFile(val: any) {
    if (!this.fileCanPreview(this.isJira ? val.filename : val.name)) {
      return;
    }
    const axiosConfig = this.isJira
      ? {
          method: 'post',
          url: `${config.neo}/Feedback/GetJiraFile`,
          headers: {
            'Authorization': `Bearer ${this.tokens.access_token}`,
            'Content-Type': 'application/json'
          },
          data: JSON.stringify({ url: val.content }),
          responseType: 'blob'
        }
      : {
          method: 'get',
          url: `${config.neo}/Upload/FileLoad${val.filePath}`,
          headers: {
            Authorization: `Bearer ${this.tokens.access_token}`
          },
          responseType: 'blob'
        };

    axios(axiosConfig)
      .then((res) => {
        const blob = res.data;
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = (e: any) => {
          this.previewFileUrl = e.target.result;
          this.previewVisible = true;
        };
      })
      .catch((err: any) => {
        this.$message.error(`文件预览失败`);
      });
  }

  downloadFile(fileName: string, filePath: string) {
    const axiosConfig = this.isJira
      ? {
          method: 'post',
          url: `${config.neo}/Feedback/GetJiraFile`,
          headers: {
            'Authorization': `Bearer ${this.tokens.access_token}`,
            'Content-Type': 'application/json'
          },
          data: JSON.stringify({ url: filePath }),
          responseType: 'blob'
        }
      : {
          method: 'get',
          url: `${config.neo}/Upload/FileLoad${filePath}`,
          headers: {
            Authorization: `Bearer ${this.tokens.access_token}`
          },
          responseType: 'blob'
        };

    axios(axiosConfig)
      .then((res) => {
        const blob = res.data;
        if (window.navigator.msSaveBlob) {
          // IE10+ 使用的下载方式
          return window.navigator.msSaveBlob(blob, fileName);
        }
        // 其他浏览器下载方式
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = (e: any) => {
          const a: any = document.createElement('a');
          a.download = fileName;
          a.href = e.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
      })
      .catch((err: any) => {
        this.$message.error(`文件${fileName}下载失败`);
      });
  }

  // 下载附件
  downloadAttachment() {
    const fileList: any[] = this.selectedAttachment;
    if (fileList.length === 0) {
      return this.$message.warning('请选择需要下载的附件');
    }
    for (const item of fileList) {
      if (this.isJira) {
        this.downloadFile(item.filename, item.content);
      } else {
        this.downloadFile(item.fileName, item.filePath);
      }
    }
  }

  // 文件类型图标
  getFileIconClass(name: string) {
    if (
      name.endsWith('jpg') ||
      name.endsWith('bmp') ||
      name.endsWith('jpeg') ||
      name.endsWith('png')
    ) {
      return 'iconfont icontupian';
    }
    if (name.endsWith('ppt') || name.endsWith('pptx')) {
      return 'iconfont iconppt';
    }
    if (name.endsWith('doc') || name.endsWith('docx')) {
      return 'iconfont iconword';
    }
    if (name.endsWith('xls') || name.endsWith('xlsx')) {
      return 'iconfont iconExcel';
    }
    if (name.endsWith('txt')) return 'iconfont icontxt';
    if (name.endsWith('pdf')) return 'iconfont iconpdf';

    return 'iconfont iconqitaleixingwenjian';
  }

  getFileAClass(name: string) {
    if (
      name.endsWith('jpg') ||
      name.endsWith('bmp') ||
      name.endsWith('jpeg') ||
      name.endsWith('png')
    ) {
      return 'can-preview';
    }

    return 'none';
  }

  fileCanPreview(name: string) {
    return (
      name.endsWith('jpg') ||
      name.endsWith('bmp') ||
      name.endsWith('jpeg') ||
      name.endsWith('png')
    );
  }

  // 文件大小单位转换
  filterType(val: number) {
    if (!val || val === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(val) / Math.log(k));

    return (val / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
  }
}
